export default {
  HiddenPricing: 'HIDDEN_PRICING',
};
